<template>
  <div class="home-page">
    <SiteHeader />

    <section class="hero fade-section">
      <div
        :class="['hero-stage', { 'hero-stage--dragging': isSwiping }]"
        @touchstart="handleTouchStart"
        @touchmove="handleTouchMove"
        @touchend="handleTouchEnd"
      >
        <div
          v-for="(slide, index) in heroSlides"
          :key="slide.alt"
          class="hero-card"
          :class="{ 'hero-card--active': index === activeSlide }"
          :style="computeSlideStyle(index)"
          @click="setActiveSlide(index)"
        >
          <img :src="slide.src" :alt="slide.alt" />
        </div>
      </div>
      <div class="hero-indicators">
        <button
          v-for="(slide, index) in heroSlides"
          :key="`indicator-${slide.alt}`"
          type="button"
          :class="['hero-indicator', { 'hero-indicator--active': index === activeSlide }]"
          @click="setActiveSlide(index)"
          aria-label="切换头图"
        ></button>
      </div>
    </section>

    <section class="intro-panel fade-section">
      <h2>
        欢迎访问新闻所历史网
      </h2>
      <p>
        自 1978 年成立至今，中国社会科学院新闻与传播研究所已走过了卌载春秋。从成立时的新闻研究所，到 1997 年更名后的新闻与传播研究所，一路走来，新老同仁代代接续，不忘初心，治学报国，卓有所成。
      </p>
      <p>
        我们致力于保存新闻社在不同时期留下的重要文献与记录，包括稿件、报道、影像与出版物等，作为珍贵的历史资料对公众开放。通过妥善的保存与合理的利用，我们希望让这些档案为社会、学界以及所有关心历史的人士提供服务。
      </p>
    </section>

    <section class="news-section fade-section">
      <div class="section-heading">
        <div class="heading-left">
          <img :src="images.newsIcon" alt="" />
          <span>最新资讯</span>
        </div>
        <button class="heading-link">
          全部
          <img :src="images.newsMore" alt="更多" />
        </button>
      </div>
      <div class="news-list">
        <article v-for="item in newsItems" :key="item.title" class="news-card">
          <div class="news-date">{{ item.date }}</div>
          <h3 class="news-title">{{ item.title }}</h3>
          <p class="news-excerpt">{{ item.excerpt }}</p>
        </article>
      </div>
    </section>

    <section class="archive-section fade-section">
      <div class="section-heading section-heading--compact">
        <div class="heading-left">
          <img :src="images.newsIcon" alt="" />
          <span>本所资料</span>
        </div>
      </div>
      <div class="resource-grid">
        <article
          v-for="(card, idx) in resourceCards"
          :key="card.title"
          :class="['resource-card', { show: visibleCards.includes(idx) }]"
          ref="resourceCards"
        >
          <div class="resource-image">
            <img :src="card.image" :alt="card.title" />
          </div>
          <div class="resource-body">
            <div class="resource-title">
              <span>{{ card.title }}</span>
              <img :src="images.arrowIcon" alt="" />
            </div>
            <p>{{ card.description }}</p>
          </div>
        </article>
      </div>
    </section>

    <SiteFooter />
  </div>
</template>
<script>
import SiteHeader from '@/components/SiteHeader.vue';
import SiteFooter from '@/components/SiteFooter.vue';

export default {
  components: {
    SiteHeader,
    SiteFooter
  },
  data() {
    const images = {
      newsIcon: require('./assets/img/SketchPngd0813b395ff458231bce60a96d8e7163ae13b7ebc25b06b227a49bcc75f56609.png'),
      newsMore: require('./assets/img/SketchPng55499522ceed767f58e0a1752d057d91302c4ee9539cab52f42dd8d6bf392f23.png'),
      arrowIcon: require('./assets/img/SketchPng72895929e9819fcf2124c82845d59a576118c9b4c94b94e6940eb31665ba5704.png')
    };

    return {
      images,
      heroSlides: [
        {
          src: require('./assets/img/3d3a8ce7aadf46d9b83988ec93acc0d5_mergeImage.png'),
          alt: '历史影像一'
        },
        {
          src: require('./assets/img/82062b9f49d8433cbcf5994beed13703_mergeImage.png'),
          alt: '历史影像二'
        },
        {
          src: require('./assets/img/556c2d75e0484b9fa35a0d5e7e9f1120_mergeImage.png'),
          alt: '历史影像三'
        }
        //{
         // src: require('./assets/img/SketchPngd0813b395ff458231bce60a96d8e7163ae13b7ebc25b06b227a49bcc75f56609.png'),
        //  alt: '历史影像四'
        //}
      ],
      activeSlide: 0,
      rotationTimer: null,
      visibleCards: [],
      touchStartX: null,
      touchStartY: null,
      touchDeltaX: 0,
      isSwiping: false,
      newsItems: [
        {
          date: '2025.08.22',
          title: '传播中华文明的普世价值 建构中国文化的话语力量',
          excerpt:
            '2011年12月18日，在以“中国力量，文明价值”为主题的“2011中国第三届文明论坛”上，我所学者张丹和杨瑞明主持和承担的国家社科基金重点项目“普世价值的传播与中国的话语权”课题组发布了主题研究报告（之一）《重新认识中华文明的价值》。该报告针对如何破解中华文明传播的价值密码、如何构建当代中国的全球影响力这一重大历史与现实问题，展开了深入探讨与战略前瞻，成为此届“文明论坛…'
        },
        {
          date: '2025.08.22',
          title: '中国传播学发展30年：1978-2008——所重大课题',
          excerpt:
            '本课题是2007年9月立项的所重大研究课题之一，课题组成员主要由该所研究人员组成，其研究成果已通过课题结项，并于2010年7月由中国大百科出版社出版为学术专著——《中国传播学30年：1978--2008》。该书主编是王怡红、胡翼青，副主编为张丹、杨瑞明，新闻与传播研究所所长尹韵公研究员为该书撰写了总序。'
        }
      ],
      resourceCards: [
        {
          title: '机构与历史',
          description:
            '中国社会科学院新闻与传播研究所成立于中国改革开放扬帆起航的 1978 年。它的创建，是党和国家领导人在拨乱反正进程中重启新闻学科建设的重要举措。',
          image: require('./assets/img/SketchPng0d16e3f62cccb30c67f14f915f91b948eb53ca5769a542474ee1d6a9a10863ea.png')
        },
        {
          title: '学科与科研',
          description:
            '随着改革开放的深入，新闻研究所与时俱进，引进或开拓了一系列新的研究领域，如传播学、公共关系学、舆论学、受众调查、新闻法治、新媒体研究等。',
          image: require('./assets/img/SketchPngf3940c4145cbfb2d91e9795c1942450ce5ade0fdde586f432ad55a58411e75a9.png')
        },
        {
          title: '教育与人才',
          description:
            '2001 年，新闻系开始由中国社会科学院新闻与传播研究所单独管理。40 年来，新闻系为中国新闻业培养了大批高素质的领军人才，被誉为中国新闻界的“黄埔军校”。',
          image: require('./assets/img/SketchPnga65d7402ef086be4f149e33c6a620188be10ea65881edefe02eb98363613dcc7.png')
        },
        {
          title: '传播与平台',
          description:
            '目前，本所已经形成以“一刊两鉴两辑刊”为主体的学术传播格局。《新闻与传播研究》成为国内本学科最具影响力的学术刊物，在引领学术方向上成绩显著。',
          image: require('./assets/img/SketchPngd86680213eb3bc42ccce4a7593f9a3c106b580c34f47d4e09e099d0a23358eda.png')
        }
      ]
    };
  },
  mounted() {
    this.startAutoRotation();
    this.initCardObserver();
  },
  beforeDestroy() {
    this.stopAutoRotation();
    if (this.cardObserver) {
      this.cardObserver.disconnect();
    }
  },
  methods: {
    setActiveSlide(index) {
      this.activeSlide = index;
      this.resetAutoRotation();
    },
    changeSlide(step) {
      if (!this.heroSlides.length) {
        return;
      }
      const total = this.heroSlides.length;
      const nextIndex = (this.activeSlide + step + total) % total;
      this.setActiveSlide(nextIndex);
    },
    getRelativeOffset(index) {
      const total = this.heroSlides.length;
      let diff = index - this.activeSlide;
      if (diff > total / 2) {
        diff -= total;
      } else if (diff < -total / 2) {
        diff += total;
      }
      return diff;
    },
    computeSlideStyle(index) {
      const offset = this.getRelativeOffset(index);
      const shift = this.getCardShift();
      let dragOffset = 0;
      if (this.isSwiping && this.touchDeltaX !== 0) {
        if (offset === 0) {
          dragOffset = this.touchDeltaX * 0.65;
        } else if (Math.abs(offset) === 1) {
          dragOffset = this.touchDeltaX * 0.15 * (offset > 0 ? 1 : -1);
        }
      }
      const translateX = offset * shift + dragOffset;
      const isMobile = this.isMobileViewport();
      const translateY = offset === 0 ? -20 : isMobile ? -6 : -10;
      const scale = offset === 0 ? 1 : isMobile ? 0.95 : 0.9;
      const opacity = Math.abs(offset) > 1 ? 0.4 : 1;
      const zIndex = 3 - Math.min(Math.abs(offset), 2);
      return {
        transform: `translateX(calc(-50% + ${translateX}px)) translateY(${translateY}px) scale(${scale})`,
        opacity,
        zIndex
      };
    },
    getCardShift() {
      if (typeof window === 'undefined') {
        return 320;
      }
      const width = window.innerWidth;
      if (width <= 640) {
        const gutter = 32;
        const cardWidth = Math.min(520, width - gutter * 2);
        const stageWidth = width;
        const maxShift = (stageWidth - cardWidth) / 2;
        return Math.max(12, Math.min(maxShift, 80));
      }
      if (width <= 1024) return 220;
      return 320;
    },
    isMobileViewport() {
      if (typeof window === 'undefined') return false;
      return window.innerWidth <= 640;
    },
    startAutoRotation() {
      this.stopAutoRotation();
      this.rotationTimer = setInterval(() => {
        const next = (this.activeSlide + 1) % this.heroSlides.length;
        this.activeSlide = next;
      }, 10000);
    },
    stopAutoRotation() {
      if (this.rotationTimer) {
        clearInterval(this.rotationTimer);
        this.rotationTimer = null;
      }
    },
    resetAutoRotation() {
      this.startAutoRotation();
    },
    initCardObserver() {
      if (!('IntersectionObserver' in window)) {
        this.visibleCards = this.resourceCards.map((_, idx) => idx);
        return;
      }
      this.cardObserver = new IntersectionObserver(entries => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            const idx = Number(entry.target.dataset.index);
            if (!this.visibleCards.includes(idx)) {
              this.visibleCards.push(idx);
            }
            this.cardObserver.unobserve(entry.target);
          }
        });
      }, { threshold: 0.2 });

      this.$nextTick(() => {
        const cards = this.$refs.resourceCards || [];
        cards.forEach((el, idx) => {
          if (el) {
            el.dataset.index = idx;
            this.cardObserver.observe(el);
          }
        });
      });
    },
    handleTouchStart(event) {
      if (!event.touches || !event.touches.length) {
        return;
      }
      const touch = event.touches[0];
      this.touchStartX = touch.clientX;
      this.touchStartY = touch.clientY;
      this.touchDeltaX = 0;
      this.isSwiping = false;
    },
    handleTouchMove(event) {
      if (this.touchStartX === null || !event.touches || !event.touches.length) {
        return;
      }
      const touch = event.touches[0];
      const deltaX = touch.clientX - this.touchStartX;
      const deltaY = touch.clientY - this.touchStartY;
      if (!this.isSwiping) {
        if (Math.abs(deltaX) > 10 && Math.abs(deltaX) > Math.abs(deltaY)) {
          this.isSwiping = true;
        } else {
          return;
        }
      }
      event.preventDefault();
      this.touchDeltaX = deltaX;
    },
    handleTouchEnd() {
      if (this.touchStartX === null) {
        return;
      }
      if (this.isSwiping && Math.abs(this.touchDeltaX) > 45) {
        this.changeSlide(this.touchDeltaX > 0 ? -1 : 1);
      }
      this.touchStartX = null;
      this.touchStartY = null;
      this.touchDeltaX = 0;
      this.isSwiping = false;
    }
  }
};
</script>
<style scoped lang="css" src="./assets/index.css" />
